// Image uploads pass through the backend (in-memory processing) — keep this
// conservative to prevent OOMs. Videos upload directly to Mux via a presigned
// URL and never touch backend memory, so they can be much larger.
export const IMAGE_MAX_SIZE_BYTES = 100 * 1024 * 1024
export const VIDEO_MAX_SIZE_BYTES = 500 * 1024 * 1024

export const IMAGE_MAX_SIZE_LABEL = '100MB'
export const VIDEO_MAX_SIZE_LABEL = '500MB'
